import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DashboardIndicadores, DashboardIndicadoresDiariosService, IndicadorInfo } from '../..';
import { catchErr } from 'src/app/shared/utils';

@Component({
    selector: 'app-dashboard-indicadores-diarios',
    templateUrl: './dashboard-indicadores-diarios.component.html',
    styleUrls: ['./dashboard-indicadores-diarios.component.css'],
    standalone: false
})
export class DashboardIndicadoresDiariosComponent implements OnInit {
    loading = false;
    today = new Date();
    indicadoresDiarios: IndicadorInfo[] = [];

    constructor(
        private service: DashboardIndicadoresDiariosService,
        private snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {
        this.fetchIndicadores();
    }

    private fetchIndicadores(): void {
        this.loading = true;
        this.service.getIndicadoresDiarios().subscribe({
            next: (diarios: DashboardIndicadores) => {
                this.indicadoresDiarios = [
                    {
                        titulo: 'Criados',
                        valor: diarios.criados,
                        icone: 'add_circle',
                        cor: 'primary',
                        descricao: 'Quantidade total de DIOs criados no dia vigente',
                        periodicidade: 'Diário'
                    },
                    {
                        titulo: 'Executados',
                        valor: diarios.executados,
                        icone: 'check_circle',
                        cor: 'success',
                        descricao: 'Quantidade de DIOs executados pelos condutores no dia vigente',
                        periodicidade: 'Diário'
                    },
                    {
                        titulo: 'Aguardando Execução',
                        valor: diarios.naoExecutados,
                        icone: 'cancel',
                        cor: 'warn',
                        descricao: 'Quantidade de DIOs ainda não executados pelos condutores no dia vigente',
                        periodicidade: 'Diário'
                    },
                    {
                        titulo: 'Executor',
                        valor: diarios.executor,
                        icone: 'pending_actions',
                        cor: 'accent',
                        descricao: 'Quantidade de DIOs pendentes de atesto do Funcionário no dia vigente',
                        periodicidade: 'Diário'
                    },
                    {
                        titulo: 'Aferição',
                        valor: diarios.afericao,
                        icone: 'assessment',
                        cor: 'primary',
                        descricao: 'Quantidade de DIOs pendentes de aferição no dia vigente',
                        periodicidade: 'Diário'
                    },
                    {
                        titulo: 'Fiscal',
                        valor: diarios.fiscal,
                        icone: 'gavel',
                        cor: 'accent',
                        descricao: 'Quantidade de DIOs pendentes de validação do Fiscal no dia vigente',
                        periodicidade: 'Diário'
                    },
                ];
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    getCorClasse(cor: string): string {
        const cores: { [key: string]: string } = {
            'primary': 'text-primary',
            'success': 'text-success',
            'warn': 'text-danger',
            'accent': 'text-warning'
        };
        return cores[cor] || 'text-primary';
    }
}
